import * as React from 'react';

export interface IButtonProps{
    text: string;
    href?: string;
    onClick?: () => void;
    classes?: string[];
    disabled?: boolean;
    // Opt in to rendering `text` as authored HTML. Off by default so existing
    // callers keep escaping their labels as plain text.
    allowHtml?: boolean;
}

import * as styles from './Button.module.scss';
import { containsAnchor, looksLikeHtml } from '../../services/html.service';

export const ButtonStyles = styles;

export const Button = (props: IButtonProps) => {
    const { text, classes, href, onClick, disabled, allowHtml } = props;

    // A CMS value containing an anchor has to replace our wrapper rather than sit
    // inside it - nesting anchors produces broken markup. The authored anchor
    // brings its own href and styling, so ours are not applied.
    // The wrapper exists only because dangerouslySetInnerHTML cannot target a
    // fragment; inline-block keeps it a real box so it still participates in the
    // parent's flex/grid layout and spacing rules.
    if(allowHtml && containsAnchor(text)){
        return (
            <span style={{ display: 'inline-block' }} dangerouslySetInnerHTML={{ __html: text }} />
        )
    }

    return(
        <a className={ disabled ? [styles.button, styles.disabledButton].join(" ") : [styles.button].concat(classes || [styles.defaultButton]).join(" ") } href={ href } onClick={ onClick && !disabled ? onClick : (() => null) }>
            {
                allowHtml && looksLikeHtml(text) ? (
                    <span dangerouslySetInnerHTML={{ __html: text }} />
                ) : (
                    <span>{ text }</span>
                )
            }
        </a>
    )
}